import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-light-svg-icons';
import SubMenu, { SubMenuListItem as Li } from '../SubMenu';
import SubMenuTitle from '../SubMenu/SubMenuTitle';
import CollapsingMenu from '../CollapsingMenu';
import MenuLink from '../MenuLink';

const SettingsMenu = ({ sidebarCollapsed, isOpen, onShowHide, isProUser }) => (
	<CollapsingMenu
		Icon={() => (
			<FontAwesomeIcon
				style={{ pointerEvents: 'none' }}
				fixedWidth
				size="lg"
				icon={faCog}
			/>
		)}
		isCollapsed={sidebarCollapsed}
		onClick={onShowHide}
		open={isOpen}
		title="Settings"
		className="settings"
	>
		<SubMenu label="Settings">
			{/* <Li> */}
			{/*	<SubMenuTitle title="Carriers" /> */}
			{/*	<SubMenu> */}
			{/*		<Li> */}
			{/*			<MenuLink to="/settings/10">SFTP Account</MenuLink> */}
			{/*		</Li> */}
			{/*		<Li> */}
			{/*			<MenuLink to="/settings/1">API Keys</MenuLink> */}
			{/*		</Li> */}
			{/*		<Li> */}
			{/*			<MenuLink to="/settings/16">Webhooks</MenuLink> */}
			{/*		</Li> */}
			{/*	</SubMenu> */}
			{/* </Li> */}

			{/* <Li> */}
			{/*	<MenuLink to="/settings/2">Auto-manifesting</MenuLink> */}
			{/* </Li> */}

			{isProUser && (
				<Li>
					<SubMenuTitle title="Allocation Windows" />
					<SubMenu>
						<Li>
							<MenuLink to="/shipments/allocationWindowExclusions">
								Allocation Window Exclusions
							</MenuLink>
						</Li>
						<Li>
							<MenuLink to="/shipments/postMidnightAllocationWindows">
								Post Midnight Allocations
							</MenuLink>
						</Li>
					</SubMenu>
				</Li>
			)}

			<Li>
				<SubMenuTitle title="Carriers" />
				<SubMenu>
					{isProUser && (
						<Li>
							<MenuLink to="/shipments/carrier-account-settings">
								Carrier Accounts
							</MenuLink>
						</Li>
					)}

					{/*		<Li> */}
					{/*			<MenuLink to="/settings/4">Carrier Connectors</MenuLink> */}
					{/*		</Li> */}

					{isProUser && (
						<>
							<Li>
								<MenuLink to="/shipments/carriers">
									Carrier Services
								</MenuLink>
							</Li>
							<Li>
								<MenuLink to="/shipments/carrier-service-group">
									Carrier Service Groups
								</MenuLink>
							</Li>
						</>
					)}
				</SubMenu>
			</Li>

			<Li>
				<MenuLink to="/shipments/multiTenancy">Multi-tenancy</MenuLink>
			</Li>

			{/* <Li> */}
			{/*	<MenuLink to="/settings/7">Custom State Labels</MenuLink> */}
			{/* </Li> */}

			{/* {isProUser && ( */}
			{/*	<Li> */}
			{/*		<MenuLink to="/settings/8">Dangerous Goods</MenuLink> */}
			{/*	</Li> */}
			{/* )} */}

			{/* <Li> */}
			{/*	<MenuLink to="/settings/9">Notification Centre</MenuLink> */}
			{/* </Li> */}

			{/* <Li> */}
			{/*	<SubMenuTitle title="Shipments" /> */}
			{/*	<SubMenu> */}
			{/*		<Li> */}
			{/*			<MenuLink to="/settings/11">Shipment Filters</MenuLink> */}
			{/*		</Li> */}
			{/*		<Li> */}
			{/*			<MenuLink to="/settings/12"> */}
			{/*				Shipment Groupings */}
			{/*			</MenuLink> */}
			{/*		</Li> */}
			{/*	</SubMenu> */}
			{/* </Li> */}

			{isProUser && (
				<Li>
					<SubMenuTitle title="Shipping" />
					<SubMenu>
						<Li>
							<MenuLink to="/shipments/shippingLocations">
								Shipping Locations
							</MenuLink>
						</Li>
						<Li>
							<MenuLink to="/shipments/shippingModes">
								Shipping Modes
							</MenuLink>
						</Li>
						<Li>
							<MenuLink to="/shipments/shippingRules">
								Shipping Rules
							</MenuLink>
						</Li>
					</SubMenu>
				</Li>
			)}
			{/* <Li> */}
			{/*	<MenuLink to="/settings/15">Tracking Pages</MenuLink> */}
			{/* </Li> */}
		</SubMenu>
	</CollapsingMenu>
);

SettingsMenu.propTypes = {
	sidebarCollapsed: PropTypes.bool.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onShowHide: PropTypes.func.isRequired,
	isProUser: PropTypes.bool.isRequired
};

export default SettingsMenu;
